import React from "react";

const Education = () => {
  const data = [
    {
      id: 1,
      duration: "2015 - 2017",
      degree: "Masters, Computer Science",
      university: "Northeastern University, Boston",
      details: "GPA (3.8/4.0)",
    },
    {
      id: 2,
      duration: "2003 - 2007",
      degree: "Bachelors, Electronics",
      university: "APJ Abdul Kalam Technical University, India",
      details: "GPA (3.5/4.0)",
    },
  ];

  return (
    <div
      name="education"
      className="w-full h-screen md:h-fit sm:h-fit bg-gradient-to-b from-gray-800 to-black  via-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-cent w-full h-full pt-20">
        <div className="pb-4 pt-5">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500 text-white">
            Education
          </p>
        </div>

        <div className="pt-4 mt-10">
          {data.map((item, id) => (
            <ol
              key={id}
              className="flex flex-col md:flex-row  border-l border-stone-200"
            >
              <li className="mb-10 ml-4">
                <p className="flex flex-wrap gap-4 flex-row items-center justify-start mb-3">
                  <span className="font-bold text-2xl px-2 inline-block">
                    {item.degree}
                  </span>
                  <span className="text-xl px-2 inline-block text-gray-400">
                    {item.university}
                  </span>
                  <span className="font-normal text-lg px-2 inline-block text-stone-400">
                    {item.duration}
                  </span>
                </p>
                <p>
                  <span className="pt-5 px-2 text-base font-normal text-stone-500">
                    {item.details}
                  </span>
                </p>
              </li>
            </ol>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Education;
